import PhoneInput from './component';
import { PhoneInputProps } from './types';

export default PhoneInput;
export type { PhoneInputProps };
